import React from 'react';
import Actions from '../actions/Actions';
import ContentPDF from '../../../../components/content-pdf/ContentPDF';

type Props = {
  data: string;
  isFullScreen: boolean;
  isPreview?: boolean;
  goBack?: () => void;
};

function Pdf(props: Props) {
  const { data, isFullScreen, isPreview, goBack } = props;
  return (
    <Actions fullScreen={isFullScreen} isPreview={isPreview} goBack={goBack}>
      <ContentPDF data={data}/>
    </Actions>
  );
}

export default Pdf;
